import api from "../security/api";

const viewEmailsFindAll = (client, instance) => {
    return api
        .get(`emails/findAll?client=${client}&instance=${instance}`);
};

const emailsService = {
    viewEmailsFindAll
};


export default emailsService;
